/** Per-user isolation for browser-local BBG data (IndexedDB + localStorage). */

export const LEGACY_LIBRARY_DB_NAME = 'bookbuildergo-library'
export const LEGACY_LIBRARY_OWNER_KEY = 'bbg-library-legacy-owner-v1'

const GUEST_USER_ID = 'guest'

let activeStorageUserId: string | null = null

export function sanitizeUserId(userId: string): string {
  return String(userId || GUEST_USER_ID)
    .trim()
    .replace(/[^a-zA-Z0-9_-]+/g, '_')
    .slice(0, 120) || GUEST_USER_ID
}

export function libraryDbName(userId: string): string {
  return `bookbuildergo-library-${sanitizeUserId(userId)}`
}

export function userStoragePrefix(userId: string): string {
  return `bbg-${sanitizeUserId(userId)}`
}

export function userLocalStorageKey(userId: string, suffix: string): string {
  return `${userStoragePrefix(userId)}-${suffix}`
}

export function customLibraryFoldersKey(userId: string): string {
  return userLocalStorageKey(userId, 'library-custom-folders')
}

export function libraryMigrationDoneKey(userId: string): string {
  return userLocalStorageKey(userId, 'library-scoped-migration-v1')
}

export function literaLocalStorageMigrationDoneKey(userId: string): string {
  return userLocalStorageKey(userId, 'litera-scoped-migration-v1')
}

export function setActiveStorageUserId(userId: string | null | undefined): void {
  activeStorageUserId = userId ? sanitizeUserId(userId) : null
}

export function getActiveStorageUserId(): string | null {
  return activeStorageUserId
}

export function requireActiveStorageUserId(): string {
  if (!activeStorageUserId) {
    throw new Error('No active storage user — log in to access library data.')
  }
  return activeStorageUserId
}

export function resolveStorageUserId(userId?: string | null): string {
  if (userId) return sanitizeUserId(userId)
  return requireActiveStorageUserId()
}
